module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/sven-d90139ddb314765077b8fb91ca472e31.jpg";